import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { plateNumberAction } from 'redux/actions'
import styles from './YourInformation.module.scss'

const PlateNumber = ({ t, plateNumberValid, validatePlateNumber, plateNumberError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const { masterNumber, plateNumber } = useSelector((state) => state.app)

  const handlePlateNumber = (e) => {
    try {
      let number = e.currentTarget.value.replace(/\s/g, '').toUpperCase()
      dispatch(plateNumberAction(number))
      // validatePlateNumber(number)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleOnBlur = () => {
    SetIsFocussed(false)
    validatePlateNumber(plateNumber)
  }

  return (
    <React.Fragment>
      <div className={styles['fields_margin']}>
        <div
          className={
            plateNumberValid === true
              ? plateNumber !== '' && 'form-group has-success'
              : plateNumberValid === false && 'form-group ns-form-group-message-error'
          }
        >
          <label className="control-label" htmlFor="PlateNumber">
            <b>{t('your_information.plate_number')}</b>
          </label>
          {plateNumberValid === false && (
            <div className="ns-form-error-container has-error error-msg-align">
              <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
              <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(plateNumberError)}</div>
            </div>
          )}
          <input
            type="text"
            className={['form-control', styles['field_width_100']].join(' ')}
            id="PlateNumber"
            // onBlur={handleOnBlur}
            value={plateNumber}
            autoComplete="off"
            onChange={handlePlateNumber}
            onFocus={() => SetIsFocussed(true)}
            maxLength="7"
          />
          {plateNumberValid === true && plateNumber !== '' && (
            <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(PlateNumber)
